import React from 'react'
import Layout from '../../Layout/Layout'
import giz_partner1 from '../../images/giz_partner1.PNG'

import giz_partner2 from '../../images/giz_partner2.PNG'



const Partnership_giz_dtc = () => {
  return (
   <Layout>
        <div className='uk-container'>
            <div><h2 className='light uk-text-bold uk-margin-xlarge-top'>GIZ/DTC</h2></div>


            <div className='uk-grid'>
               <div className='uk-width-1-2@s'>
                      <p className='light'>
                        Moolu Venture Lab was distinguished by its selection as one of the
                         Top 10 Innovation Support Organizations (ISOs) in Nigeria, chosen 
                         from a pool of 250 innovation hubs to participate in the prestigious
                          GIZ/Digital Transformation Center (DTC) capacity development program.
                           This selection is a significant recognition of the Lab's reputation as
                            a trusted enabler and a leading force within Nigeria’s dynamic innovation
                             ecosystem. It validates Moolu Venture Lab's track record and expertise in
                              successfully supporting and scaling enterprises across the country.
</p>

                <p className='light'>The program's core objective is to enhance the support provided
                     to non-tech Micro, Small, and Medium Enterprises (MSMEs), placing a strong 
                     emphasis on accelerating their digital transformation journey. GIZ/DTC achieves 
                     this by providing the selected ISOs, like Moolu Venture Lab, with essential 
                     resources, advanced training, and financial subsidies. This strategic support 
                     is designed to build the ISOs' capacity to better empower MSMEs in adopting 
                     digital tools, thereby improving their operational efficiency and driving 
                     long-term sustainable growth.
</p>
               </div>

                <div className='uk-width-1-2@s'>
                  <img src= {giz_partner1} />
               </div>
            </div>


                
            <div className='uk-grid uk-margin-large-top'>
               <div className='uk-width-1-2@s'>
                   <img src= {giz_partner2} />
               </div>

                <div className='uk-width-1-2@s'>

                             <p className='light'>
                        Moolu Venture Lab was distinguished by its selection as one of the
                         Top 10 Innovation Support Organizations (ISOs) in Nigeria, chosen 
                         from a pool of 250 innovation hubs to participate in the prestigious
                          GIZ/Digital Transformation Center (DTC) capacity development program.
                           This selection is a significant recognition of the Lab's reputation as
                            a trusted enabler and a leading force within Nigeria’s dynamic innovation
                             ecosystem. It validates Moolu Venture Lab's track record and expertise in
                              successfully supporting and scaling enterprises across the country.
</p>

                <p className='light'>The program's core objective is to enhance the support provided
                     to non-tech Micro, Small, and Medium Enterprises (MSMEs), placing a strong 
                     emphasis on accelerating their digital transformation journey. GIZ/DTC achieves 
                     this by providing the selected ISOs, like Moolu Venture Lab, with essential 
                     resources, advanced training, and financial subsidies. This strategic support 
                     is designed to build the ISOs' capacity to better empower MSMEs in adopting 
                     digital tools, thereby improving their operational efficiency and driving 
                     long-term sustainable growth.
</p>
            
               </div>
            </div>





        </div>
        </Layout>
  )
}

export default Partnership_giz_dtc